var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var _ref2;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.015625,
    width: 59.4524,
    height: 59.4524,
    rx: 10.2504,
    fill: "#86D4A1",
    style: (_ref2 = {
      fill: "#86D4A1"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.5262 0.8317 0.6307)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9688 31.722C17.9688 30.8519 18.6749 30.1457 19.5451 30.1457H22.6977C23.5678 30.1457 24.274 30.8519 24.274 31.722V41.18C24.274 42.0501 23.5678 42.7563 22.6977 42.7563H19.5451C19.127 42.7563 18.7261 42.5902 18.4304 42.2946C18.1348 41.999 17.9688 41.598 17.9688 41.18V31.722ZM27.4267 25.4168C27.4267 24.5466 28.1329 23.8404 29.003 23.8404H32.1556C33.0258 23.8404 33.732 24.5466 33.732 25.4168V41.18C33.732 42.0501 33.0258 42.7563 32.1556 42.7563H29.003C28.5849 42.7563 28.184 42.5902 27.8884 42.2946C27.5927 41.999 27.4267 41.598 27.4267 41.18V25.4168ZM36.8846 19.1115C36.8846 18.2413 37.5908 17.5352 38.4609 17.5352H41.6136C42.4837 17.5352 43.1899 18.2413 43.1899 19.1115V41.18C43.1899 42.0501 42.4837 42.7563 41.6136 42.7563H38.4609C38.0428 42.7563 37.6419 42.5902 37.3463 42.2946C37.0507 41.999 36.8846 41.598 36.8846 41.18V19.1115Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.26106,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.f27bd76b.svg";
export { ForwardRef as ReactComponent };